<template>
  <div>
    <div class="px-15">
      <tabs
        @selected="handleSelectedTab"
        module="members"
        :current="currentTab"
      ></tabs>
    </div>
    <div v-if="selectedTab">
      <members v-if="currentTab == 0" @showModal="handleShowModal"></members>
      <groups v-if="currentTab == 1" @showModal="handleShowModal"></groups>
    </div>
  </div>
</template>

<script>
import Tabs from "../components/Tabs";
import Members from "../components/manage-members/Members";
import Groups from "../components/manage-members/Groups";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "admin-products",
  components: {
    Tabs,
    Members,
    Groups
  },
  data: () => ({
    selectedTab: null
  }),
  computed: {
    currentTab() {
      return this.GET_USER_TAB();
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    ...mapGetters({
      GET_USER_TAB: "GET_USER_TAB"
    }),
    ...mapActions({
      USER_SET_TAB: "USER_SET_TAB"
    }),
    handleSelectedTab(tab) {
      this.selectedTab = tab;
      this.USER_SET_TAB(tab.id);
    },
    handleAdd() {
      this.handleShowModal({ name: this.selectedTab.modalName });
    },
    handleEdit(item) {
      this.handleShowModal({
        name: this.selectedTab.modalName.replace("add", "edit"),
        ...item
      });
    },
    handleShowModal(config) {
      this.$emit("showModal", config);
    }
  }
};
</script>
